import React, { useEffect, useState } from "react";
import { ModalWithHeader } from "../shared/ui/Modal/ModalNew";
import {
  Box,
  Button,
  Chip,
  Divider,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { ModalTextField2 } from "../shared/ui/Modal/ModalTextfield";
import DoneButton from "../shared/ui/Modal/DoneButton";
import { useTranslation } from "react-i18next";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocationModal from "../LocationModal/LocationModal";

const GoogleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const professions = [
  "AI Strategy Consultants",
  "Machine Learning Engineers",
  "Data Scientists & Analytics Experts",
  "AI Implementation Specialists",
  "Industry-Specific AI Consultants",
  "AI Infrastructure & DevOps Experts",
  "Generative AI & LLM Specialists",
  "AI Ethics & Governance Experts",
];

const ExpertModal = ({
  show,
  closeModal,
  updateValueMessage,
  UpdateExpertPost,
  expertPost,
}) => {
  const address = JSON.parse(localStorage.getItem("address"));

  const lat = JSON.parse(localStorage.getItem("lat"));
  const lng = JSON.parse(localStorage.getItem("lng"));
  const [expertDetails, setExpertDetails] = useState(
    expertPost || {
      profession: "",
      location: address,
      expertDesc:
        "I’m looking for a high quality professional in nearby area. Does anyone have a recommendation?",
    }
  );
  const { t } = useTranslation();
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [coordinates, setCoordinates] = useState({
    lat: lat,
    lng: lng,
  });

  const handleExpertDetails = (e) => {
    const { name, value } = e.target;
    setExpertDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    updateValueMessage(expertDetails.expertDesc);
    UpdateExpertPost(expertDetails);
    closeModal();
  };

  const handleCoordinatesChange = (coor) => {
    setCoordinates(coor);
  };

  const handleAddress = (address) => {
    setExpertDetails((prev) => ({ ...prev, location: address }));
  };

  return (
    <>
      <LocationModal
        show={showLocationModal}
        closeModal={() => setShowLocationModal(false)}
        method={handleAddress}
        coordinates={coordinates}
        setCoordinates={handleCoordinatesChange}
      />
      <Box
        sx={{
          background: "#fff",
          borderRadius: "0px 0px 15px 15px",
        }}
      >
        <Divider sx={{ background: "rgba(0,0,0,0.08)" }} />
        <form onSubmit={handleSubmit}>
          <Box
            sx={{
              maxHeight: "60vh",
              overflowY: "scroll",
              display: "flex",
              flexDirection: "column",

              mb: { xs: 5, lg: 0 },
            }}
          >
            <Box
              sx={{
                background: "#f2f8fc",
                position: "relative",
                maxHeight: "40vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                width: "100%",
                mb: 2,
              }}
            >
              <img
                src="/Image/DashboardImages/postModImages/post_expert.png"
                alt="event cover"
                style={{ objectFit: "contain", height: "40vh" }}
              />
            </Box>
            <Box sx={{ padding: "0px 20px" }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "600", mb: 2 }}>
                {t("expertModal.headline")}
              </Typography>

              <Typography sx={{ fontSize: "12px", fontWeight: "400" }}>
                {t("expertModal.ques")}*
              </Typography>
              <FormControl fullWidth margin="normal" sx={{ mt: 1 }}>
                <Select
                  value={expertDetails.profession}
                  onChange={(e) =>
                    setExpertDetails((prev) => ({
                      ...prev,
                      profession: e.target.value,
                    }))
                  }
                  sx={{
                    "& .MuiOutlinedInput-input": {
                      padding: "5px 14px",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "secondary.main",
                    },
                  }}
                  MenuProps={{
                    sx: {
                      "&& .Mui-selected": {
                        backgroundColor: "rgba(0,116,228,0.08)",
                      },
                    },
                  }}
                >
                  {professions.map((profession, index) => (
                    <MenuItem
                      key={index}
                      value={profession}
                      sx={{
                        "&.MuiMenuItem-root .Mui-selected": {
                          backgroundColor: "rgba(0,116,228,0.08)",
                        },
                      }}
                    >
                      {profession}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Typography sx={{ fontSize: "12px", fontWeight: "400", mt: 2 }}>
                {t("expertModal.location")}*
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Chip
                  icon={<LocationOnIcon color="#000" />}
                  label={
                    expertDetails?.location
                      ? `${expertDetails?.location?.slice(0, 37)}...`
                      : "Select a location"
                  }
                  sx={{
                    mt: 1,
                    color: "#000",
                    fontSize: "15px",
                    fontWeight: 600,
                    lineHeight: "20px",
                  }}
                />
                <Button
                  onClick={() => setShowLocationModal(true)}
                  disableRipple
                  sx={{
                    ml: 1,
                    mt: 1,
                    ":hover": {
                      background: "none",
                    },
                    color: "#007A85",
                    fontSize: "15px",
                    fontWeight: 600,
                    lineHeight: "20px",
                    textTransform: "none",
                  }}
                >
                  Edit
                </Button>
              </Box>

              <Box>
                <img
                  src={`https://maps.googleapis.com/maps/api/staticmap?center=${coordinates.lat},${coordinates.lng}&zoom=17&size=700x200&markers=icon:http://stage-nxnearby-assets.s3.ap-south-1.amazonaws.com/media/static/favicon.ico|${coordinates.lat},${coordinates.lng}&maptype=terrain&key=${GoogleMapsApiKey}&style=feature:administrative.land_parcel%7Celement:geometry.fill%7Cweight:4&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd&style=feature:administrative.locality%7Celement:geometry.fill%7Cweight:5&style=feature:administrative.neighborhood%7Celement:geometry.fill%7Cweight:5.5&style=feature:administrative.province%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:landscape%7Celement:geometry.fill%7Ccolor:0xfcfcfc&style=feature:landscape.natural.landcover%7Celement:geometry.fill%7Ccolor:0xe9f7c4&style=feature:landscape.natural.terrain%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:poi%7Celement:labels.text.stroke%7Ccolor:0xffffff&style=feature:poi.attraction%7Celement:geometry.fill%7Cweight:5&style=feature:poi.business%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi.government%7Celement:geometry.fill%7Ccolor:0xffdfba%7Cweight:4&style=feature:poi.medical%7Celement:geometry.fill%7Cweight:4.5&style=feature:poi.park%7Celement:geometry.fill%7Ccolor:0xbaffc9&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:poi.place_of_worship%7Cvisibility:off&style=feature:poi.place_of_worship%7Celement:geometry.fill%7Ccolor:0xffb3ba&style=feature:poi.school%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi.sports_complex%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:road%7Celement:geometry%7Ccolor:0xffffff&style=feature:road%7Celement:geometry.fill%7Clightness:10&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161&style=feature:road.local%7Celement:geometry.fill%7Ccolor:0xe0e0e0%7Clightness:40%7Cweight:5&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9&style=feature:water%7Celement:geometry.fill%7Ccolor:0xc0faff&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e`}
                  style={{ marginTop: 16, borderRadius: 16, width: "95%" }}
                />
              </Box>

              <Typography sx={{ fontSize: "12px", fontWeight: "400", mt: 2 }}>
                {t("expertModal.desc")}*
              </Typography>
              <ModalTextField2
                value={expertDetails.expertDesc}
                method={handleExpertDetails}
                name={"expertDesc"}
                multiline={true}
                rows={4}
                inputProp={{ maxLength: 750 }}
              />
            </Box>
          </Box>
          <DoneButton
            backMethod={closeModal}
            type="submit"
            disabled={
              expertDetails.profession === "" ||
              expertDetails.location === "" ||
              expertDetails.expertDesc === ""
                ? true
                : false
            }
          />
        </form>
      </Box>
    </>
  );
};

export default ExpertModal;
